import React from 'react';
import { Dialog } from 'primereact/dialog';

/**
 * "Padrão do Imóvel" — explicação de como o padrão de um empreendimento é classificado,
 * aberta pelo "?" ao lado do cabeçalho Padrão das tabelas do painel de resultados.
 *
 * Porte dos ModalPadraoInfo / ModalPadraoInfoComercial / ModalPadraoInfoCasas do mapa
 * Google (react-bootstrap), que continuam intactos lá. Aqui os três viraram um só
 * componente em PrimeReact — a única diferença entre eles era o texto e a tabela de
 * faixas, então cada tipo de empreendimento é uma variante.
 *
 * Os textos e as faixas são cópia literal do legado: quem edita um lado tem que editar
 * o outro enquanto os dois mapas coexistirem.
 */

const FAIXAS_VERTICAL = [
    ['Compacto', 'Studio - Loft - 1 quarto'],
    ['Econômico', 'Até 400.000'],
    ['Standard', 'de 400.001 até 1.000.000'],
    ['Médio', 'de 1.000.001 até 2.000.000'],
    ['Médio-Alto', 'de 2.000.001 até 3.000.000'],
    ['Alto', 'de 3.000.001 até 5.000.000'],
    ['Luxo', 'Acima de 5.000.000'],
];

// Casas/sobrados usam as mesmas faixas do vertical, sem o "Compacto" (que é
// classificação por tipologia, não por preço).
const FAIXAS_CASAS = FAIXAS_VERTICAL.filter(([padrao]) => padrao !== 'Compacto');

const FAIXAS_COMERCIAL = [
    ['Econômico', 'Até 6.000 m² priv.'],
    ['Standard', 'De 6.001 a 8.000 m² priv.'],
    ['Médio', 'De 8.001 a 10.000 m² priv.'],
    ['Alto', 'De 10.001 a 12.000 m² priv.'],
    ['Alto +', 'Acima de 12.001 m² priv.'],
];

const TEXTO_VERTICAL =
    'Classificação do padrão de valor de um empreendimento conforme o preço médio de ' +
    'vendas de suas unidades em termos de faixas de valor. Ressalte-se a especificidade ' +
    'da assim chamada faixa “Compacto” que contempla ao menos 50% de suas unidades com ' +
    'imóveis pequenos de estúdios, lofts e 1 dormitório, não tendo uma classificação ' +
    'prévia de preço, mas sim de tipologia. Isolou-se essa tipologia por compreender que ' +
    'sua lógica de preço deve ser avaliada em particular por ser um produto residencial ' +
    'porém com “menor” característica familiar e mais de investimento. Segue tabela:';

const TEXTO_CASAS =
    'Classificação do padrão de valor de um empreendimento conforme o preço médio de ' +
    'vendas de suas unidades em termos de faixas de valor. Segue tabela:';

const TEXTO_COMERCIAL =
    'A classificação dos padrões em empreendimentos comerciais é feita a partir da faixa ' +
    'de valor do m² privativo, sendo assim:';

const VARIANTES = {
    vertical:  { texto: TEXTO_VERTICAL,  faixas: FAIXAS_VERTICAL },
    casas:     { texto: TEXTO_CASAS,     faixas: FAIXAS_CASAS },
    comercial: { texto: TEXTO_COMERCIAL, faixas: FAIXAS_COMERCIAL },
};

/**
 * @param {{variante: 'vertical'|'casas'|'comercial'|null, onHide: () => void}} props
 *        `variante` nula mantém o modal fechado (é o estado de "nenhum ? clicado").
 */
export default function PadraoInfoModal({ variante, onHide }) {
    const conteudo = variante ? VARIANTES[variante] : null;

    return (
        <Dialog
            header="Padrão do Imóvel"
            visible={Boolean(conteudo)}
            onHide={onHide}
            modal
            dismissableMask
            style={{ width: '42rem', maxWidth: '95vw' }}
        >
            {conteudo && (
                <>
                    <p className="text-justify">{conteudo.texto}</p>

                    <table className="table table-striped table-condensed table-padroes">
                        <thead>
                            <tr className="text-center" style={{ backgroundColor: '#5B7537', color: '#fff' }}>
                                <th className="text-center" style={{ color: '#fff', padding: 7 }}>Padrão</th>
                                <th className="text-center" style={{ color: '#fff', padding: 7 }}>Faixa de Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {conteudo.faixas.map(([padrao, faixa]) => (
                                <tr className="text-center" key={padrao}>
                                    <td className="text-center">{padrao}</td>
                                    <td className="text-center">{faixa}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}
        </Dialog>
    );
}
